import { render } from "./StatsWidgetTitleRender.vue?vue&type=template&id=2be31222"
import script from "./StatsWidgetTitleRender.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetTitleRender.vue?vue&type=script&lang=ts"

import "./StatsWidgetTitleRender.vue?vue&type=style&index=0&id=2be31222&lang=scss"
script.render = render

export default script